export function buildAnalyticsPayload(event, metadata = {}) {
    return {
        platform: 'web',
        user_type: 'staff',
        surface_type: event.surfaceType,
        ...(metadata.parent || event.parent ? { parent: metadata.parent || event.parent } : {}),
        ...(metadata.contentId !== undefined && metadata.contentId !== null && metadata.contentId !== ''
            ? { content_id: String(metadata.contentId).slice(0, 200) }
            : {}),
        ...(metadata.content ? { content: String(metadata.content).slice(0, 500) } : {}),
    }
}
